import { onUpArrowPressedSearchInput } from '../actions/internalActions';
import { changeSelectedSuggestionViaKeyboard } from '../actions/publicActions';
import { getStore } from '../store/store';
import { orchestrator } from 'satcheljs';
export default orchestrator(onUpArrowPressedSearchInput, function () {
    // Bail if there isn't a complete suggestion set in the store.
    var currentSuggestionSet = getStore().currentSuggestions;
    if (!currentSuggestionSet || !currentSuggestionSet.IsComplete) {
        return;
    }
    var selectedSuggestionIndex = getStore().selectedSuggestionIndex;
    var suggestionsCount = currentSuggestionSet.Suggestions.length;
    /**
     * If user isn't already at the top of the SuggestionsContextMenu (i.e.
     * selectedSuggestionIndex === 0) and the index is valid (i.e. between 0
     * and the count of suggestions displayed), then we'll move the selected
     * index.
     */
    if (selectedSuggestionIndex > 0 && selectedSuggestionIndex < suggestionsCount) {
        // User is going "up" in the UI, so decrease the index.
        var indexToSelect = selectedSuggestionIndex - 1;
        // Get suggestion to be selected.
        var suggestionToSelect = currentSuggestionSet.Suggestions[indexToSelect];
        // Dispatch action to change selected index.
        changeSelectedSuggestionViaKeyboard(indexToSelect, suggestionToSelect);
    }
});
//# sourceMappingURL=onUpArrowPressedSearchInputOrchestrator.js.map